export const getDashboardRoutes = (routes) =>
  routes
    .filter((r) => r && r.layout === "/admin" && !r.superAdminOnly)
    .map((r) => ({ path: r.path, name: r.name }));
